let sheetID = "";

export const getSheetID = (): string => {
  return sheetID;
};

export const initSheetID = () => {
  const cachedSheetUrl = localStorage.getItem("sheetID");
  const sheetIDInputElement = document.getElementById(
    "sheetIDInput"
  ) as HTMLInputElement;
  const updateSheetIDButtonElement = document.getElementById(
    "updateSheetIDButton"
  ) as HTMLButtonElement;

  sheetID = cachedSheetUrl || "";
  if (sheetIDInputElement) {
    sheetIDInputElement.value = sheetID;
    updateSheetIDButtonElement.addEventListener("click", function () {
      sheetID = sheetIDInputElement.value;
      localStorage.setItem("sheetID", sheetID);
      alert("Sheet URLが更新されました。リロードしてください。");
    });
  }
};
